module.exports = ":host ::ng-deep .menu-change {\r\n  border: none!important;\r\n  box-shadow: none!important;\r\n}"